import { NgModule } from '@angular/core';
import { SharedModule } from 'ngx-mat-esign360/lib/shared/shared.module';
import { ClientDocRelationNamePipe } from 'ngx-mat-esign360/lib/transaction/pipes/client-doc-relation-name.pipe';
import { SignatureTypeIconPipe } from './pipes/signature-type-icon.pipe';
import { SigningStateNamePipe } from './pipes/signing-state-name.pipe';
import { IsDocSignedByClientPipe } from './pipes/is-doc-signed-by-client.pipe';
import { ClientDocRelationFulfilledNamePipe } from './pipes/client-doc-relation-fulfilled-name.pipe';
import { CheckCanReadRelationPipe } from './pipes/client-doc-relation/check-can-read-relation.pipe';
import { CheckMustReadRelationPipe } from './pipes/client-doc-relation/check-must-read-relation.pipe';
import { CheckMustSignRelationPipe } from './pipes/client-doc-relation/check-must-sign-relation.pipe';
import { IsReadyToProcessDocPipe } from './pipes/is-ready-to-process-doc.pipe';

@NgModule({
  declarations: [
    ClientDocRelationNamePipe,
    SigningStateNamePipe,
    SignatureTypeIconPipe,
    IsDocSignedByClientPipe,
    ClientDocRelationFulfilledNamePipe,
    CheckCanReadRelationPipe,
    CheckMustReadRelationPipe,
    CheckMustSignRelationPipe,
    IsReadyToProcessDocPipe,
  ],
  imports: [SharedModule],
  exports: [
    ClientDocRelationNamePipe,
    SigningStateNamePipe,
    SignatureTypeIconPipe,
    IsDocSignedByClientPipe,
    ClientDocRelationFulfilledNamePipe,
    CheckCanReadRelationPipe,
    CheckMustReadRelationPipe,
    CheckMustSignRelationPipe,
    IsReadyToProcessDocPipe,
  ],
})
export class TransactionModule {}
